<template>
  <div class="indexDesc">
    <topNav :title="$t('indexDesc_title')"></topNav>
    <div class="tipBar">
      <mt-cell :title="$t('indexDesc_total_revenue')">{{$t('indexDesc_total_revenue_value')}}<br>{{$t('indexDesc_total_revenue_value1')}}
      </mt-cell>
      <mt-cell :title="$t('indexDesc_available')"
               :value="$t('indexDesc_available_value')"></mt-cell>
      <mt-cell :title="$t('indexDesc_take_up_room')"
               :value="$t('indexDesc_take_up_room_value_normal')"></mt-cell>
      <mt-cell :title="$t('indexDesc_overnight_rate')"
               :value="$t('indexDesc_overnight_rate_value')"></mt-cell>
      <mt-cell :title="$t('indexDesc_night_average')"
               :value="$t('indexDesc_night_average_value')"></mt-cell>
      <mt-cell title="REVPAR"
               :value="$t('indexDesc_REVPAR_value')"></mt-cell>
      <mt-cell :title="$t('indexDesc_total_rooms')"
               :value="$t('indexDesc_total_rooms_value')"></mt-cell>
      <mt-cell :title="$t('indexDesc_since_room')">
        {{$t('indexDesc_since_room_value')}}<br>
        {{$t('indexDesc_since_room_value1')}}
      </mt-cell>
      <mt-cell :title="$t('indexDesc_free_room')">
        {{$t('indexDesc_free_room_value')}}<br>
        {{$t('indexDesc_free_room_value1')}}
      </mt-cell>
      <mt-cell :title="$t('indexDesc_maintenance_room')">
        {{$t('indexDesc_maintenance_room_value')}}<br>
        {{$t('indexDesc_maintenance_room_value1')}}
      </mt-cell>
      <mt-cell :title="$t('indexDesc_locked_room')">
        {{$t('indexDesc_locked_room_value')}}<br>
        {{$t('indexDesc_locked_room_value1')}}
      </mt-cell>

      <!-- 本日订单信息 -->
      <mt-cell :title="$t('index_homeData_notarrRoom')"
               :value="$t('index_homeData_notarrRoom_value')"></mt-cell>
      <mt-cell :title="$t('index_homeData_isarrRoom')"
               :value="$t('index_homeData_isarrRoom_value')"></mt-cell>
      <mt-cell :title="$t('index_homeData_notdepRoom')"
               :value="$t('index_homeData_notdepRoom_value')"></mt-cell>
      <mt-cell :title="$t('index_homeData_isdepRoom')"
               :value="$t('index_homeData_isdepRoom_value')"></mt-cell>

      <div class='index-desc-notice'>
        {{$t('indexDesc_chart_desc')}}
      </div>
    </div>

  </div>
</template>

<script>
  export default {
    data() {
      return {};
    }
  };
</script>

<style lang="less">
  .indexDesc {
    background-color: #f6f8f9;

    .tipBar {
      margin-top: 0.4rem;
      padding-bottom: 1.4rem;
    }

    .mint-cell-value {
      font-size: 0.35rem;
    }

    .index-desc-notice {
      color: #999;
      width: 100%;
      text-align: right;
      font-size: 0.36rem;
      margin-top: 0.2rem;
      padding: 0 10px;
      box-sizing: border-box;
    }
  }
</style>



// WEBPACK FOOTER //
// indexDesc.vue?5675cce0